import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

import { FormControlComponent } from '../../../abstracts/form-control.abstract';
import { IQuestionChoices, IRadioCheckboxConfig } from '../../../interfaces/radio-checkbox-config.interface';

@Component({
    selector: 'app-generic-radio-checkbox',
    templateUrl: './generic-radio-checkbox.component.html',
    styleUrls: ['./generic-radio-checkbox.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: GenericRadioCheckboxComponent,
            multi: true,
        },
    ],
})
export class GenericRadioCheckboxComponent extends FormControlComponent implements OnInit, OnChanges {
    @Input() public config: IRadioCheckboxConfig;
    @Input() public readOnly: boolean;

    @Output() public action = new EventEmitter<number>();

    public inputType: string;
    public inputId: string;

    public questionChoices: IQuestionChoices[];

    public radioControl: FormControl;

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.radioControl = new FormControl({ value: '', disabled: this.readOnly });
        this.inputType = this.config.inputType;
        this.inputId = this.config.formGroupName;
        this.questionChoices = this.config.questionChoices;
    }

    ngOnChanges(change: SimpleChanges): void {
        if (change.config.currentValue) {
            this.questionChoices = change.config.currentValue.questionChoices;
        }
    }

    public writeValue(obj: any): void {
        if (Array.isArray(obj)) {
            this.value = [...obj];
        } else {
            this.value = obj;
        }
        this.radioControl.patchValue(obj);
    }

    public onSelectedRadio(val: any): void {
        this.value = val;
        this.onChange(val);
        if (!this.touched) {
            this.onTouched();
        }
    }

    public onSelectedCheckbox(val: any): void {
        if (Array.isArray(this.value)) {
            if (this.value.indexOf(val) < 0) {
                this.value = [...this.value, val];
            } else {
                this.value = this.value.filter((v: any) => v !== val);
            }
        } else {
            this.value = val === this.value ? !val : val;
        }

        this.onChange(this.value);
        if (!this.touched) {
            this.onTouched();
        }
    }

    public isArray(val: any): boolean {
        return Array.isArray(val);
    }
}
